module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQiIGhlaWdodD0iMTkiIHZpZXdCb3g9IjAgMCAzNCAxOSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuNSA4QzAuNjcxNTczIDggMCA4LjY3MTU3IDAgOS41QzAgMTAuMzI4NCAwLjY3MTU3MyAxMSAxLjUgMTFMMS41IDhaTTMzLjUgOS41TDE4LjUgMC44Mzk3NDZWMTguMTYwM0wzMy41IDkuNVpNMS41IDExTDIwIDExVjhMMS41IDhMMS41IDExWiIgZmlsbD0iI0I0MUIzRSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow_red.svg
// module id = c/Dt
// module chunks = 1